import sliceCreator from '../../index.jsx';
import { GET_ALL_FARMER_COMMITMENTS} from '../../../constants/index.jsx';
const _getAllFarmerCommitmentsAction = sliceCreator('GET_ALL_FARMER_COMMITMENTS', GET_ALL_FARMER_COMMITMENTS, 'get');

const { asyncAction: getAllFarmerCommitmentsAction, reducer, clearData: clearGetAllFarmerCommitmentsAction } = _getAllFarmerCommitmentsAction;

export default reducer;

export {
    getAllFarmerCommitmentsAction,
    clearGetAllFarmerCommitmentsAction
}